import { OrderGroupResponse, RepeatRiaInvestmentSelections } from 'types/add-funds';
import { currency } from '@filters/shared-filters';
import { investmentEntityRequest } from '@utils/request';
import { RepeatRiaInvestmentMetadata } from 'types/add-funds';

export async function getRepeatRiaInvestmentData(): Promise<RepeatRiaInvestmentMetadata> {
	const response = await investmentEntityRequest.get(`/repeat-investment/ria/metadata`);

	const repeatInvestmentData = response.data;

	const repeatRiaInvestmentMetadata: RepeatRiaInvestmentMetadata = {
		validRiaInvestmentRange: repeatInvestmentData.validRiaInvestmentRange,
		suggestedInvestmentAmounts: [],
		repeatRiaInvestmentSelections: repeatInvestmentData.repeatRiaInvestmentSelections,
		serviceLevelUpgradeMapping: repeatInvestmentData.serviceLevelUpgradeMapping
	};

	repeatRiaInvestmentMetadata.suggestedInvestmentAmounts = repeatInvestmentData.suggestedInvestmentAmounts.map(
		(suggestedInvestmentAmount: { amount: string; upgradeOption: boolean }) => {
			return {
				value: suggestedInvestmentAmount.amount,
				label: currency(suggestedInvestmentAmount.amount, 0) as string,
				sortIndex: suggestedInvestmentAmount.amount,
				upgradeOption: suggestedInvestmentAmount.upgradeOption
			};
		}
	);

	repeatRiaInvestmentMetadata.suggestedInvestmentAmounts.push({
		value: 'other',
		label: 'Other amount',
		sortIndex: 10000000,
		upgradeOption: false
	});

	return repeatRiaInvestmentMetadata;
}

export const cacheSelections = async (selections: RepeatRiaInvestmentSelections): Promise<void> => {
	await investmentEntityRequest.post(`/repeat-investment/ria/selections/save`, selections);
};

export const getOrderAllocation = async (amount: string, riaPlanId: string): Promise<OrderGroupResponse> => {
	const response = await investmentEntityRequest.get(`/investment/allocation`, {
		params: {
			amount: amount,
			riaPlanId: riaPlanId
		}
	});
	return response.data;
};
